import React from 'react';
import { isSafari, isIOS } from 'react-device-detect';
import { Paper, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { clsx } from 'clsx';
import { LwtCopyrightDoubleLines } from 'html-worksheets/@common/LwtCopyright';

const PortraitPaperLayout = ({
  children,
  className,
  isNarrow,
  isWide,
  addAveryText,
  printRef,
  ...props
}: {
  children: React.ReactNode;
  isNarrow?: boolean;
  isWide?: boolean;
  addAveryText?: boolean;
  printRef?: React.RefObject<HTMLDivElement>;
  className?: string;
}) => {
  const classes = useStyles();

  return (
    <Paper
      id={'print-content-portrait'}
      className={clsx(classes.portraitContainerClass, className)}
      ref={printRef}
      {...props}
    >
      <Box className={classes.wrapper}>{children}</Box>
      <LwtCopyrightDoubleLines
        isWide={isWide}
        isNarrow={isNarrow}
        addAveryText={addAveryText}
      ></LwtCopyrightDoubleLines>
    </Paper>
  );
};

export default PortraitPaperLayout;

const useStyles = makeStyles(() => ({
  portraitContainerClass: () => {
    return {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '1100px',
      width: '850px !important',
      position: 'relative',
      margin: '0 auto',
      minWidth: 'unset !important',
      ...((isSafari || isIOS) && {
        '@media print': {
          marginTop: '-40px'
        }
      })
    };
  },
  wrapper: () => ({
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    flexDirection: 'column',
    height: '1100px',
    width: '850px !important',
    position: 'relative',
    ...(isSafari && {
      '@media print': {
        paddingTop: '40px',
        paddingBottom: '0px'
      }
    })
  })
}));
